import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import UploadEmailAddresses from '@/components/email-uploads-page/UploadEmailAddresses'
import PageTitle from '@/components/PageTitle'

export default function EmailUploadsPage() {
  return (
    <>
      <PageTitle>Upload Email Addresses</PageTitle>
      <Breadcrumb
        label="Upload Email Addresses"
        url="/settings/email-uploads"
      />
      <UploadEmailAddresses />
    </>
  )
}
